import { render, staticRenderFns } from "./ProvidersManagerForm.vue?vue&type=template&id=374ea88c&"
import script from "./ProvidersManagerForm.vue?vue&type=script&lang=ts&"
export * from "./ProvidersManagerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports